import { render, staticRenderFns } from "./NewsTable.vue?vue&type=template&id=c8dd0e68&scoped=true&"
import script from "./NewsTable.vue?vue&type=script&lang=js&"
export * from "./NewsTable.vue?vue&type=script&lang=js&"
import style0 from "./NewsTable.vue?vue&type=style&index=0&id=c8dd0e68&lang=scss&scoped=true&"
import style1 from "./NewsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dd0e68",
  null
  
)

export default component.exports